import { IntroScreenUIConfig } from "../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../components/ui/scenario-info-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import GameManager from "../cvp-webgames-core/GameManager";
import Tools from "../cvp-webgames-core/Misc/Tools";
import BaseScenarioPart from "../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../cvp-webgames-core/pre-caching/pre-cache-item";
import { constants } from "../misc/constants";
import { CustomGameDataManager, PageType, updateMentorVideo } from "../misc/tools";
import { GameBaseScenario } from "./GameBaseScenario";

class Scenario1VideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Domiciliary Intake Process Setting';
    }

	public videoKey = 'Video';

	public cinematicKeys = {
		chapter1: 'chapter1', //played on step 2
		chapter1Resume: 'chapter1-resume',

		chapter2: 'chapter2', //played on step 5
		chapter2Part2: 'chapter2Part2', //played on step 5c
		chapter2Resume: 'chapter2-resume',

		chapter3: 'chapter3', //played on step 7
		chapter3Part2: 'chapter3Part2', //playes on step 7c
		chapter3Resume: 'chapter3-resume',

		chapter4: 'chapter4', //played on step 9
		chapter4Part2: 'chapter4Part2', //playes on step 9c
		chapter4Resume: 'chapter4-resume',

		chapter5: 'chapter5', //played on step 11
		chapter5Resume: 'chapter5-resume',
    };

	public get mentorVidUrl(): string {
		return this.getItems()[1].src;
	}
	public mentorKeys = { // need to update this based on srt and per question
		situation: 'mentor-2', //played on situation screen/ introduction video needs to match srt chapter name.
		mentor1Correct: 'mentor-1', //played on ____ correct
		mentor1Incorrect: 'mentor-1', //played on ____ incorrect
		review: 'mentor-3', //played on review screen
		BnScn01All001: 'Bn-Scn-01-All-001',
		BnScn01All008: 'Bn-Scn-01-All-008',
		BnScn01All010: 'Bn-Scn-01-All-010',
		BnScn01All011: 'Bn-Scn-01-All-011',
		BnScn01All013: 'Bn-Scn-01-All-013',
		BnScn01All015: 'Bn-Scn-01-All-015',
		BnScn01All016: 'Bn-Scn-01-All-016',
		BnScn01All017: 'Bn-Scn-01-All-017',
		BnScn01All019: 'Bn-Scn-01-All-019',
		BnScn01All021: 'Bn-Scn-01-All-021',
		BnScn01All022: 'Bn-Scn-01-All-022',
		BnScn01All024: 'Bn-Scn-01-All-024',
		BnScn01All026: 'Bn-Scn-01-All-026',
		BnScn01All027: 'Bn-Scn-01-All-027',
		BnScn01All029: 'Bn-Scn-01-All-029',
		BnScn01All032: 'Bn-Scn-01-All-032',
		BnScn01All036: 'Bn-Scn-01-All-036',
		BnScn01All038: 'Bn-Scn-01-All-038',
		BnScn01All040: 'Bn-Scn-01-All-040',
		BnScn01All042: 'Bn-Scn-01-All-042',
		BnScn01All043: 'Bn-Scn-01-All-043',
		BnScn01All045: 'Bn-Scn-01-All-045',
		BnScn01All047: 'Bn-Scn-01-All-047',
		BnScn01All048: 'Bn-Scn-01-All-048',
		BnScn01All050: 'Bn-Scn-01-All-050',
		BnScn01All052: 'Bn-Scn-01-All-052',
		BnScn01All053: 'Bn-Scn-01-All-053',
		BnScn01All055: 'Bn-Scn-01-All-055',
		BnScn01All061: 'Bn-Scn-01-All-061',
		BnScn01All063: 'Bn-Scn-01-All-063',
		BnScn01All065: 'Bn-Scn-01-All-065',
		BnScn01All067: 'Bn-Scn-01-All-067', 
		BnScn01All068: 'Bn-Scn-01-All-068',
		BnScn01All070: 'Bn-Scn-01-All-070', 
		BnScn01All071: 'Bn-Scn-01-All-071', 
		BnScn01All072: 'Bn-Scn-01-All-072',
		BnScn01All074: 'Bn-Scn-01-All-074', 
		BnScn01All075: 'Bn-Scn-01-All-075',
		BnScn01All077: 'Bn-Scn-01-All-077',
		BnScn01All079: 'Bn-Scn-01-All-079', 
		BnScn01All080: 'Bn-Scn-01-All-080',
		BnScn01All082: 'Bn-Scn-01-All-082',
		BnScn01All085: 'Bn-Scn-01-All-085',
		BnScn01All089: 'Bn-Scn-01-All-089',
		BnScn01All091: 'Bn-Scn-01-All-091',
		BnScn01All093: 'Bn-Scn-01-All-093',
		BnScn01All095: 'Bn-Scn-01-All-095', 
		BnScn01All096: 'Bn-Scn-01-All-096',
		BnScn01All098: 'Bn-Scn-01-All-098',
		BnScn01All100: 'Bn-Scn-01-All-100', 
		BnScn01All101: 'Bn-Scn-01-All-101',
		BnScn01All103: 'Bn-Scn-01-All-103',
		BnScn01All105: 'Bn-Scn-01-All-105', 
		BnScn01All106: 'Bn-Scn-01-All-106',
		BnScn01All108: 'Bn-Scn-01-All-108',
		BnScn01All112: 'Bn-Scn-01-All-112',
		BnScn01All113: 'Bn-Scn-01-All-113', 
		BnScn01All114: 'Bn-Scn-01-All-114', 
		BnScn01All115: 'Bn-Scn-01-All-115', 
		
    };
	
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: this.videoKey,
				src: process.env.PUBLIC_URL + '/assets/videos/scenario-01/video.mp4',
				type: PrecacheItemType.Video
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/mentor-vids/scn-01/Mentor-Bs-Scn-01-Full.mp4',
				type: PrecacheItemType.Video
			}
		];
	}
}

export const scenario1VideoSegments = new Scenario1VideoSegments();

export default class Scenario1 extends GameBaseScenario {
	public partId = 'scenario';

	public get MentorTalkingVideo(): string {
		return scenario1VideoSegments.mentorVidUrl;
    }
	
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return null;
    }

	public resumeScenarioFromArea(areaIndx: number): void {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			this.hudId = this.uiWrapper.displayHUD({
			});
			//resume on or after the first question
			let onDone: () => void = null;
			let chapterId: string = null;
			switch(areaIndx) {
				case 0:
					chapterId = scenario1VideoSegments.cinematicKeys.chapter1Resume;
					onDone = () => this.step4();
					break;
				case 1:
					chapterId = scenario1VideoSegments.cinematicKeys.chapter2Resume;
					onDone = () => this.step6();
					break;
				case 2:
					chapterId = scenario1VideoSegments.cinematicKeys.chapter3Resume;
					onDone = () => this.step8();
					break;
				case 3:
					chapterId = scenario1VideoSegments.cinematicKeys.chapter4Resume;
					onDone = () => this.step10();
					break;
				case 4:
					chapterId = scenario1VideoSegments.cinematicKeys.chapter5Resume;
					onDone = () => this.step12();
					break;
			}
	
			setTimeout(() => {
				this.playVideoChapter(this.partId, chapterId, () => {
					onDone();
				}, false)
			}, 250);
		});
	}

	public scenarioIndex(): number {
		return 0;
    } 

	public scenarioId(): PageType {
		return PageType.Scenario1;
    }
	private video: SingleVideoSegmentItem = scenario1VideoSegments.getItemByKey(scenario1VideoSegments.videoKey);

	public getScenarioVideoURL(): string {
		return this.video.src;
	}


	public introScreenInfo(): IntroScreenUIConfig {
		return null
	}

	private parts: BaseScenarioPart<GameBaseScenario>[] = [{
		partId: this.partId,
		scenario: this,
		videoUrl: [scenario1VideoSegments.getItemByKey(scenario1VideoSegments.videoKey).src],
		start: () => {
		},
		playVideoChapter: (chapterId: string, onDone: () => void) => {
			(this.playVideoChapter(this.partId, chapterId, onDone, false))
		}
	}]

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	start() {
		this.step0();
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	//load video
	step0() {
		// this.loadPart(this.partId, () => {
			this.step1();
		// });
	}

	//1.	Scenario Intro
	step1() {
		updateMentorVideo(true, scenario1VideoSegments.mentorVidUrl, scenario1VideoSegments.mentorKeys.BnScn01All001);
		this.hudId = this.uiWrapper.displayHUD({
		});
		this.uiWrapper.displayIntroScreenUI({
			title: 'Situation',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You are a clinician at a residential domiciliary and your role today is to complete the intake process with new admissions. 
					Your next visit is with Veteran Troy Jones, who has struggled with opioid and alcohol use and is now homeless. 
					Veteran Jones has agreed to seek help through the VA residential treatment program. He is escorted into the triage 
					area by the Homeless Program Coordinator who works at the VA hospital about two miles from the domiciliary.
				</p>
				<br />
				<p class="black-text">
					The goal will be to identify the ERASE techniques, bystander intervention techniques, requirements outlined in VHA Directive 5019.02, 
					and VA Handbook 5979 throughout the scenario.
				</p>
				<br />
				<p class="black-text">
					You are the triage clinician on duty when Veteran Jones arrives. You are the only clinician in the triage room with Veteran Jones.
				</p>
			</div>
			`,
			audioUrls: null, 
			spaceForMentor: true,
			onStartScenarioClicked: () => {
			this.step2();
			},
		})
	}

	//2.	Cinematic 1 (Video)
	step2() {
		this.playVideoChapter(this.partId, scenario1VideoSegments.cinematicKeys.chapter1, () => {
			this.step3();
			this.step4();
		}, false)
	}

	//3.	Display UI
	step3() {
		
	}

	//4.	Question 1
	step4(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario1VideoSegments.mentorVidUrl, scenario1VideoSegments.mentorKeys.BnScn01All008);
		const options = customOptions ?? [{
			title: 'Option 1',
			isCorrect: false,
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All010, scenario1VideoSegments.mentorKeys.BnScn01All011],
			description: 'Veteran Jones\' comments are inappropriate and make you uncomfortable. You decide not to respond to him and continue the intake process by asking the first intake question: "Please help me understand what brings you to our program today."',
			feedbackHtml: 'Not the best answer! By choosing not to acknowledge or respond to Veteran Jones\' inappropriate comments, you may send a signal that this behavior is acceptable and could encourage such behavior to continue. As defined by VHA Directive 5019.02 (3.G), "Sexual harassment is any unsolicited verbal or physical contact of a sexual nature which is threatening in character, unwelcome sexual advances, and request for sexual favors. These comments may include actions such as sexually oriented verbal kidding, teasing, or jokes; repeated sexual flirtations, advances, or proposals; or continued sexual flirtations, advances or propositions" (3.G.1-3). Being clear and forthcoming about boundaries will make it easier moving forward for Veteran Jones to know what to expect regarding treating peers, staff, and all others with respect. According to the ERASE model "Addressing" behaviors in real time is the most effective redirection. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All013]
		}, {
			title: 'Option 2',
			isCorrect: true,
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All015, scenario1VideoSegments.mentorKeys.BnScn01All016],
			description: 'You State: "Veteran Jones, please don\'t make comments like that. The goal of our meeting is to complete your intake to check you into the domiciliary. I am going to treat you with respect, and I ask that you do the same. Statements like that are inappropriate, unwelcome and could be considered harassment."',
			feedbackHtml: 'Correct! A in the ERASE Theory represents Addressing the situation in real time. This is an example of a directly worded response that is appropriate. According to VA Handbook 5979 (5. C) "Employees and contractors that have been subjected to unwelcome conduct are encouraged to inform the person(s) responsible for the conduct that it is unwelcome and offensive. If the conduct continues or the individual is uncomfortable confronting the responsible person(s) regarding the conduct, the individual should report the matter to a VA official (VA Management Official, HPC, ORMDI HPP Office) immediately. You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All019]
		}, {
			title: 'Option 3',
			isCorrect: true,
			description: 'You state: "I know you may not mean it the way I\'m taking it, but I\'m not comfortable with you speaking to me that way."',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All021, scenario1VideoSegments.mentorKeys.BnScn01All022],
			feedbackHtml: 'Correct! This is an example of a directly worded response that is appropriate. According to VA Handbook 5979 (5. C) "Employees and contractors that have been subjected to unwelcome conduct are encouraged to inform the person(s) responsible for the conduct that it is unwelcome and offensive. If the conduct continues or the individual is uncomfortable confronting the responsible person(s) regarding the conduct, the individual should report the matter to a VA official (VA Management Official, HPC, ORMDI HPP Office) immediately. You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a href="https://cfm.vssc.med.va.gov/dbr/main.cfm" target="_blank">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All024]
		}, {
			title: 'Option 4',
			isCorrect: false,
			description: 'You state: "That is completely inappropriate! I will need to call VA police to remove you from this facility."',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All026, scenario1VideoSegments.mentorKeys.BnScn01All027],
			feedbackHtml: 'Not the best answer! This is too strong as a preliminary intervention. It is normal to feel this is unwelcome conduct and can feel uncomfortable. It is important to give a clear and direct statement in order to set a boundary. Threatening to have the Veteran removed as a first response can escalate the situation. It may also make the Veteran feel unwelcome in a setting in which VA care is being sought. If you have safety concerns for yourself, patient(s), and other staff, contacting the VA police is an appropriate first action. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All029]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario1,
			subtitle: ('Question 1'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario1VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step5();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step4(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 0, 1, () => this.step2())
	}

	//5.	Cinematic 2 (Video)
	step5() {
		this.playVideoChapter(this.partId, scenario1VideoSegments.cinematicKeys.chapter2, () => {
			this.step5b();
		}, false)
	}

	//5-b.	Time passes
	step5b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario1VideoSegments.mentorVidUrl, scenario1VideoSegments.mentorKeys.BnScn01All032);

		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You continue with the intake. Near the end, as things are wrapping up you give Veteran Jones instructions on 
					where he should go next. He then stands up and says to you:
				</p>
			</div>
			`,
			spaceForMentor: true,
			onReplayContentClicked: () => {
				this.step5();
			},
			audioUrls: null,
			onStartScenarioClicked: () => {
				this.step5c();
			},
		})
	}

	//5-c.	Cinematic 2-b (Video)
	step5c() {
		this.playVideoChapter(this.partId, scenario1VideoSegments.cinematicKeys.chapter2Part2, () => {
			this.step6();
		}, false)
	}

	//6.	Question 2
	step6(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario1VideoSegments.mentorVidUrl, scenario1VideoSegments.mentorKeys.BnScn01All036);
		const options = customOptions ?? [{
			title: 'Option 1',
			isCorrect: false,
			description: 'Hoping to get the intake back on track, you decide to humor Veteran Jones and touch his biceps.',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All038],
			feedbackHtml: 'Not the best answer! By choosing to touch Veteran Jones\' biceps you may send a signal that this behavior is acceptable and could encourage such behavior to continue. As defined by VHA Directive 5019.02 (3. G), "Sexual harassment is any unsolicited verbal or physical contact of a sexual nature which is threatening in character, unwelcome, sexual advances, and request for sexual favors. These comments may include actions such as: sexually oriented verbal kidding, teasing, or jokes; repeated sexual flirtations, advances, or proposals; or continued sexual flirtations, advances or propositions" (3. G.1-3). Being clear and forthcoming about boundaries will make it easier moving forward for Veteran Jones to know what to expect regarding treating peers, staff, and all others with respect. According to the ERASE model "Addressing" behaviors in real time is the most effective redirection. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All040]
		}, {
			title: 'Option 2',
			isCorrect: false,
			description: 'You state: “I will be right back. I am going to get security so I can get you checked in.”',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All042, scenario1VideoSegments.mentorKeys.BnScn01All043],
			feedbackHtml: 'Not the best answer! This response does not "Address the harasser with a short statement or question to point out threatening or inappropriate behavior in a safe, respectful manner" as outlined by the "Direct" intervention from the bystander intervention techniques training. Using the "Direct" intervention technique provides clear communication about inappropriate behaviors that they need to stop. It is important to first send a clear message about what the behavioral expectations are and then escalate the matter as warranted if the Veteran does not comply. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All045]
		}, {
			title: 'Option 3',
			isCorrect: true,
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All047, scenario1VideoSegments.mentorKeys.BnScn01All048],
			description: 'You say to Veteran Jones: "One of the rules of the Domiciliary is that everyone will be treated with respect. Your comments to me aren\'t respectful. I would like these unwelcome comments to stop so that we can continue with your admission process."',
			feedbackHtml: 'Correct! The "Direct" intervention within the "bystander intervention techniques" training teaches to "Address the harasser with a short statement or question to point out threatening or inappropriate behavior in a safe, respectful manner." This choice also provides a clear message about what behavioral expectations are, directs the Veteran to stop the behavior and provides instruction on what will happen if the behavior stops. You should discuss the incident with the treatment team to make them aware of the inappropriate behavior. You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All050]
		}, {
			title: 'Option 4',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All052, scenario1VideoSegments.mentorKeys.BnScn01All053],
			isCorrect: true,
			description: 'You say: "I would like to be able to continue to work with you. These types of comments will prevent us from being able to work with each other and could be considered harassment. I am asking you to please stop."',
			feedbackHtml: 'Correct! This response is brief and clear. This response touches on the following ERASE model principles (R) recognize the mistreatment, (A) address the situation in real-time, and seek (S) for support after to discuss the incident with the treatment team to make them aware of the inappropriate behavior. You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All055]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario1,
			subtitle: ('Question 2'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario1VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step7();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step6(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 1, 2, () => this.step5())
	}

	//7.	Cinematic 3 (Video)
	step7() {
		this.playVideoChapter(this.partId, scenario1VideoSegments.cinematicKeys.chapter3, () => {
			this.step7b();
		}, false)
	}

	//7-b.	Time passes
	step7b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario1VideoSegments.mentorVidUrl, scenario1VideoSegments.mentorKeys.BnScn01All113);

		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					The next day...
				</p>
			</div>
			`,
			onReplayContentClicked: () => {
				this.step7();
			},
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step7c();
			},
		})
	}

	//7-c.	Cinematic 3 Part 2 (Video)
	step7c() {
		this.playVideoChapter(this.partId, scenario1VideoSegments.cinematicKeys.chapter3Part2, () => {
			this.step8();
		}, false)
	}

	//8.	Question 3
	step8(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario1VideoSegments.mentorVidUrl, scenario1VideoSegments.mentorKeys.BnScn01All061);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All063],
			isCorrect: false,
			description: 'Ignore what you observed and do nothing.',
			feedbackHtml: 'Not the best answer! According to bystander intervention techniques, as a bystander, it is important to remember the strategy of the four "D\'s" which are Direct- Address the harasser with a short statement or questions to point out the threatening or inappropriate behavior in a safe, respectful manner; Distract- Use a subtle and creative way to draw or divert attention. Engage the person being harassed without getting involved with the harasser or referring to the harassment. Instead, talk about something completely unrelated; Delegate- Get assistance from a third party; and Document- Write down the details of the incident. Use this technique to engage in the situation in some way in order to send a message that a behavior is not appropriate. Not addressing the inappropriate behavior can encourage such behavior to continue. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All065]
		}, {
			title: 'Option 2',
			isCorrect: true,
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All067, scenario1VideoSegments.mentorKeys.BnScn01All068],
			description: 'You say: "Veteran Jones, may I speak to you for a moment?"',
			feedbackHtml: 'Correct! This is an example the Direct Intervention technique. The two of you move to another part of the room for privacy. "I noticed that you paid a great deal of attention to that other Veteran that just walked by, and it sounded like you might have made an inappropriate joke. I also saw what appeared to me as a sexually suggestive gesture after Veteran Smith passed by you. If that was the case, I need to give you feedback that we treat everyone with respect here and these actions are not respectful. Please do not use sexually suggestive gestures or make derogatory comments." You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All070, scenario1VideoSegments.mentorKeys.BnScn01All071, scenario1VideoSegments.mentorKeys.BnScn01All072]
		}, {
			title: 'Option 3',
			isCorrect: true,
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All074, scenario1VideoSegments.mentorKeys.BnScn01All075],
			description: 'You say: "Veteran Smith, I meant to check in with you about your homework questions from this afternoon\'s group." You walk with Veteran Smith out of earshot and eyesight of Veteran Jones.',
			feedbackHtml: 'Correct! While this response does not convey a direct message to Veteran Jones about a problem, it does highlight Distract, one of the four "D\'s" from the bystander intervention techniques. This is a subtle and creative way to draw away or divert attention. It directly engages the person being harassed without getting involved with the harasser or referring to the harassment. Instead, talk about something completely unrelated. If you don\'t feel comfortable confronting Veteran Jones you can choose to use the Delegate, another one of the "D\'s" techniques. This consists of getting assistance from a third party for them to intervene such as another VA employee or police officer. You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All077]
		}, {
			title: 'Option 4',
			isCorrect: false,
			description: 'You say: "Knock it off! Leave Veteran Smith alone - if you keep that up, we are going to discharge you immediately."',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All079, scenario1VideoSegments.mentorKeys.BnScn01All080],
			feedbackHtml: 'Not the best answer! Much too strong! Providing direct feedback is useful in this scenario. However, tone and delivery are important and threatening discharge should not be your first response. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All082]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario1,
			subtitle: ('Question 3'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There is more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario1VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step9();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step8(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 2, 3, () => this.step7())
	}

	//9.	Cinematic 4 (Video)
	step9() {
		this.playVideoChapter(this.partId, scenario1VideoSegments.cinematicKeys.chapter4, () => {
			this.step9b();
		}, false)
	}

	//9-b.	Time passes
	step9b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario1VideoSegments.mentorVidUrl, scenario1VideoSegments.mentorKeys.BnScn01All085);

		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
				Later in the day, you see Veteran Jones talk to this same Veteran in the hallway at dinner. He sits next to Veteran Smith, 
				and you see Veteran Smith lean away from him as he gets close and starts talking to Veteran Smith. Given what you observed 
				earlier in the day and what you know about expecting that harassment may happen, you decide to get closer to check 
				in on the situation and you hear Veteran Jones say:
				</p>
			</div>
			`,
			onReplayContentClicked: () => {
				this.step9();
			},
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step9c();
			},
		})
	}

	//9-c.	Cinematic 3 Part 2 (Video)
	step9c() {
		this.playVideoChapter(this.partId, scenario1VideoSegments.cinematicKeys.chapter4Part2, () => {
			this.step10();
		}, false)
	}

	//10.	Question 4
	step10(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario1VideoSegments.mentorVidUrl, scenario1VideoSegments.mentorKeys.BnScn01All089);
		const options = customOptions ?? [{
			title: 'Option 1',
			isCorrect: false,
			description: 'Ignore the comment. Veteran Smith looks like they are about to get up and walk away from him anyway. Veteran Smith has got this handled!',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All091],
			feedbackHtml: 'Not the best answer! You have now seen this Veteran interact inappropriately on several occasions and direct intervention of some sort is warranted. You might also consider checking in with the person this Veteran has been targeting. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All093]
		}, {
			title: 'Option 2',
			isCorrect: false,
			description: 'You yell across the room: "Veteran Jones! We\'ve talked about this! Please interact with everyone in this program with respect!"',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All095, scenario1VideoSegments.mentorKeys.BnScn01All096],
			feedbackHtml: 'Not the best answer! Yelling across the room is too strong. This could be seen as shameful, disrespectful, aggressive, or reinforcing the behavior. It may escalate the situation rather than diffuse it. You should consider a few things such as how the Veteran will receive this message. It also may be helpful to consider how the targeted Veteran is responding to the attention they are receiving. Tone and delivery of responses are important, so Veteran Jones feels respected. It is important for the clinician to model respectful behavior on the unit. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All115]
		}, {
			title: 'Option 3',
			isCorrect: true,
			description: 'You approach the Veterans and say: "Excuse me, I need to check in with Veteran Jones for a moment." You pull the Veteran aside and then say "Veteran Jones, I would like everyone to feel that they are welcome and can expect safety and respect in this program. That includes you and that also includes Veteran Smith I\'ve seen you talking to. Please keep in mind that everyone comes here to get treatment and may not be interested in a date. Please use this program to focus on yourself and your treatment goals."',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All100, scenario1VideoSegments.mentorKeys.BnScn01All101],
			feedbackHtml: 'Correct! This clearly communicates a message that the VA wants all to feel welcome and that the Veteran\'s behaviors need to be addressed. You might also consider following up directly with the Veteran who is receiving the extra attention to see how she is feeling about it. You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All103]
		}, {
			title: 'Option 4',
			mentorVid: scenario1VideoSegments.mentorVidUrl,
			mentorOption: [scenario1VideoSegments.mentorKeys.BnScn01All105, scenario1VideoSegments.mentorKeys.BnScn01All106],
			isCorrect: true,
			description: 'You approach the Veterans and say: "Excuse me, I need to check in with Veteran Smith for a moment." You pull Veteran Smith aside and state "I just wanted to be sure everything is going ok, I noticed that you are getting a lot of extra attention and we know that sometimes that can feel challenging." After your conversation is wrapped up with Veteran Smith, you say to Veteran Jones separately "Veteran Jones, we\'ve addressed this type of behavior previously and we need you to stick to your program and avoid making inappropriate comments, like asking other Veterans out on a date. Are you able to do that?"',
			feedbackHtml: 'Correct! This both addresses the behavior directly as well as provides support to the person experiencing what they might consider harassment if the attention is unwanted. You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>.',
			mentorFeedback: [scenario1VideoSegments.mentorKeys.BnScn01All108]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario1,
			subtitle: ('Question 4'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There is more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario1VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step11();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step10(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 3, 4, () => this.step9())
	}

	//11.	Cinematic 5 (Video)
	step11() {
		this.playVideoChapter(this.partId, scenario1VideoSegments.cinematicKeys.chapter5, () => {
			this.step12();
		}, false)
	}

	//12.	Scenario Recap
	step12() {
		updateMentorVideo(false, scenario1VideoSegments.mentorVidUrl, scenario1VideoSegments.mentorKeys.BnScn01All112);
		this.setAreaForCurrentScenario(4, 5).then(() => {
			this.uiWrapper.displayIntroScreenUI({
				title: 'Scenario Completed',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<p class="black-text">Congratulations! You have  completed this scenario. Here's a quick review of what was covered:
					<br />
                    <ul class="bullet">
                        <li class="black-text">Importance of direct and clear responses.</li>
                        <li class="black-text">Bystander intervention technique-Four D's highlighted.</li>
                        <li class="black-text">Necessary to address inappropriate behaviors in real time versus avoidance.</li>
                        <li class="black-text">Maintain a respectful interaction with the Veteran utilizing clear expectations.</li>
                        <li class="black-text">Unless safety requires, do not begin with the most punitive response to redirect Veteran engagement.</li>
                    </ul>
					</p>
				</div>
				`,
				audioUrls: null,
				onStartScenarioClicked: () => {
					this.step13();
				}
			})
		})
	}

	//13.	AAR
	step13() {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			savedData.data.scenarios[this.scenarioIndex()].isCompleted = true;
			Tools.saveGame(savedData).then(() => {
				this.uiWrapper.displayAAR(PageType.Scenario2);
			})
		})
	}
}